import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Distributor } from '../../model/distributor.model';
import { AdaService } from '../../../shared/services/ada.service';

@Component({
  selector: 'app-distributor-info',
  templateUrl: './distributor-info.component.html',
  styleUrls: ['./distributor-info.component.scss']
})
export class DistributorInfoComponent implements OnInit {

  @Input() distributor: Distributor = new Distributor({name: 'Default Distributor'});
  @Input() showUpdateButton = true;
  @Input() trainingExpired = false;
  @Input() showDaysRemaining = false;
  @Input() daysBeforeRenewal = 0;

  @Output() onUpdateRequest: EventEmitter<string> = new EventEmitter<string>();

  updateRequestText = '';
  popupVisible = false;

  public page: PageInfo = {
    title: 'Distributor Info'
  }

  constructor(private _adaService: AdaService) { }

  ngOnInit() {
  }

  updateRequest() {
    this.popupVisible = true;
  }

  sendRequest() {
    this.onUpdateRequest.emit(this.updateRequestText);
    this.popupVisible = false;
  }

  get adaService() {
    return this._adaService;
  }

}

export class PageInfo {
  title: string;
  subTitle?: string;
  header?: string;
}



// WEBPACK FOOTER //
// ./src/app/distributor/components/distributor-info/distributor-info.component.ts